import axios from 'axios';
import { GlobalSearchApiResponse, GlobalSearchItem } from '../types/globalSearch.types';

const apiURL = process.env.REACT_APP_API_URL;

export const getGlobalSearchResults = async (query: string): Promise<GlobalSearchItem[] | undefined> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    try {
        const response = await axios.get(`https://${apiURL}/search?q=${query}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        });

        return response.data
    } catch (error) {
        console.log(error)
    }
};